import { FeatureFlag } from '../FeatureFlag';

/**
 * Enables per-column filters on the LAB v2 Cost Info grid (ADR 0014, CC-008): header filter
 * buttons on string columns, the column editor, and the header summary of active filters. Off
 * means no column filter applies, even one set before the flag turned off (AC-FILTER-009).
 */
export const enableLab2CostInfoColumnFilters = new FeatureFlag({
    key: 'enable-lab-2-cost-info-column-filters',
    createdOn: '2026-10-22',
    defaultValue: false,
});
